const INITIAL_STATE = {
    id: "",
    name: "",
    description: "",
    application_id: ""
};

export default function (state = INITIAL_STATE, action) {
    if (action.type === "SET_ROLE_DATA") {
        return {...state, ...action.payload};
    } else {
        return state;
    }
}
